import { clusterColor } from '../utils';

const pointStyle = (
  document,
  selectedDocument,
  mousedOverDocument,
  mousedOverCluster,
  clusterData,
  cluster_id,
  nearestDocument,
  selectedCluster,
  displayedDocIds,
  searchWasPerformed
) => {
  const document_id = document.id;

  const documentIsSelected =
    selectedDocument && selectedDocument.id === document_id;
  const documentIsMousedOver = mousedOverDocument === document_id;

  const clusterIsSelected =
    selectedCluster !== false && selectedCluster === cluster_id;
  const clusterIsMousedOver = mousedOverCluster === cluster_id;

  const documentIsClosestToCursor =
    nearestDocument && nearestDocument.id === document_id;

  const doumentIsSearchResult =
    displayedDocIds.includes(document_id) && searchWasPerformed;

  const color =
    documentIsSelected || documentIsMousedOver || clusterIsMousedOver
      ? 'gold'
      : clusterColor(clusterData.filter((c) => c.id === cluster_id)[0]);

  let radius = 4;
  radius += doumentIsSearchResult ? 3 : 0;
  radius += clusterIsSelected || clusterIsMousedOver ? 2 : 0;
  radius += documentIsSelected ? 2 : 0;
  radius += documentIsClosestToCursor ? 2 : 0;
  radius += documentIsMousedOver ? 4 : 0;

  radius *= 2;

  let opacity;
  if (documentIsSelected) {
    opacity = 1;
  } else if (doumentIsSearchResult) {
    opacity = 1;
  } else {
    opacity = 0.4;
  }

  return { color, radius, opacity };
};

export { pointStyle };
